export function getFieldError (errors, field) {
  const fieldError = errors.find(error => error.field === field)
  return fieldError ? fieldError.message : ''
}

export const validateHour = {
  getMessage (field, val) { return 'Hora inválida' },

  validate (value, field) {
    let reg = new RegExp('(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')
    return ((value && value.length > 4) && reg.test(value))
  }
}

export const maxDate = (value, { max } = {}) => {

  if (value.indexOf('_') < 0) {
    return new Date(value.split('/').reverse().join()).getTime() <= new Date(max).getTime()
  }

  return true
}
